import Objective from '@/components/nested-list/nested-list-item//Objective.vue';
import Activity from '@/components/nested-list/nested-list-item/Activity.vue';
import ActivityTemplate from '@/components/nested-list/nested-list-item/ActivityTemplate.vue';
import CourseDashboard from '@/components/nested-list/nested-list-item/CourseDashboard.vue';
import Enrollments from '@/components/nested-list/nested-list-item/Enrollments.vue';
import Generic from '@/components/nested-list/nested-list-item/Generic.vue';
import Gradebook from '@/components/nested-list/nested-list-item/Gradebook.vue';
import GradebookPreview from '@/components/nested-list/nested-list-item/GradebookPreview.vue';
import Heading from '@/components/nested-list/nested-list-item/Heading.vue';
import ImportEnrollments from '@/components/nested-list/nested-list-item/ImportEnrollments.vue';
import Section from '@/components/nested-list/nested-list-item/Section.vue';
import SectionTemplate from '@/components/nested-list/nested-list-item/SectionTemplate.vue';
import StudentGradebook from '@/components/nested-list/nested-list-item/StudentGradebook.vue';

export default {
    Activity,
    ActivityTemplate,
    CourseDashboard,
    Generic,
    Heading,
    Section,
    SectionTemplate,
    Gradebook,
    GradebookPreview,
    Enrollments,
    ImportEnrollments,
    StudentGradebook,
    Objective,
};
